var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMyContacts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_335_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C14.4302 0 17.6169 3.10802 17.6169 6.9423C17.6169 8.57361 17.0398 10.0739 16.0736 11.2589C19.1386 13.1342 21 16.3999 21 19.9363C21 20.5239 20.5114 21 19.909 21H1.09102C0.488642 21 0 20.5239 0 19.9363C0 16.3994 1.86137 13.1342 4.92643 11.2589C3.96074 10.0739 3.38311 8.57361 3.38311 6.9423C3.38311 3.10802 6.56981 0 10.5 0ZM14.3875 12.7577C13.2702 13.4701 11.9343 13.8841 10.5 13.8841C9.06567 13.8841 7.7298 13.4701 6.61246 12.7577C4.23349 13.9863 2.60117 16.2694 2.25207 18.8725H18.7479C18.3994 16.2694 16.7665 13.9863 14.3875 12.7577ZM10.5 1.70625C7.77404 1.70625 5.56462 4.28321 5.56462 6.9423C5.56462 9.60088 7.77404 11.7566 10.5 11.7566C13.226 11.7566 15.4354 9.60088 15.4354 6.9423C15.4354 4.28321 13.226 1.70625 10.5 1.70625Z",
    fill: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 11.1641L15.8488 11.2972L15.9953 11.3868C19.017 13.2356 20.85 16.4535 20.85 19.9363C20.85 20.4374 20.4321 20.85 19.909 20.85H1.09102C0.567856 20.85 0.15 20.4374 0.15 19.9363C0.15 16.453 1.98303 13.2356 5.00472 11.3868L5.15118 11.2972L5.04271 11.1641C4.09778 10.0047 3.53311 8.53745 3.53311 6.9423C3.53311 3.19436 6.64911 0.15 10.5 0.15C14.3509 0.15 17.4669 3.19436 17.4669 6.9423C17.4669 8.53749 16.9027 10.0047 15.9573 11.1641ZM14.4564 12.6244L14.3797 12.5848L14.3069 12.6312C13.2131 13.3286 11.9051 13.7341 10.5 13.7341C9.09486 13.7341 7.78688 13.3286 6.6931 12.6312L6.62032 12.5848L6.54363 12.6244C4.12237 13.8749 2.4592 16.1996 2.1034 18.8526L2.08061 19.0225H2.25207H18.7479H18.9194L18.8966 18.8526C18.5413 16.1996 16.8776 13.8749 14.4564 12.6244ZM10.5 1.55625C7.67886 1.55625 5.41462 4.21327 5.41462 6.9423C5.41462 9.6872 7.69472 11.9066 10.5 11.9066C13.3053 11.9066 15.5854 9.6872 15.5854 6.9423C15.5854 4.21327 13.3211 1.55625 10.5 1.55625Z",
    stroke: "black",
    strokeWidth: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_335_3",
    x: -4,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_335_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_335_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMyContacts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MyContacts.8b401a44.svg";
export { ForwardRef as ReactComponent };